import React, { useEffect, useState } from "react";
import { Layer } from "thorium-ui";
import { getDevPosts } from "../../utils/getDevPosts";
import DevCard from "./DevCard";

const DevPosts = (props) => {
   const [devPosts, setDevPosts] = useState(null);

   useEffect(() => {
      const getDevData = async () => {
         setDevPosts(await getDevPosts());
      };
      getDevData();
   }, []);

   return (
      <>
         <h1 className="text-center">Recent Blog Posts</h1>
         <Layer justify="center" className="dev-card-container mx-0">
            {devPosts &&
               devPosts
                  .slice(0, 4)
                  .map((post, ind) => (
                     <DevCard key={ind} post={post} visible={props.visible} />
                  ))}
         </Layer>
      </>
   );
};

export default DevPosts;
